import React from 'react'
import { appMethod as app } from '@utils/app';
import OfficialPage from '../../official-page/OfficialPage';
import "./Recharge.less";
export default class RechargeGpt extends OfficialPage {
  state = {
    isWeiXinBrowser: false,
    userInfo: app.getUserInfo(),
    canUseIntegral: 0,
    userVipCardInfo: null, //会员信息
    integralList: [],
    vipList: [],
    selectId: '',
    selectPrice: null,
    comboid: '',
    shouldPayPrice: 0,
    timer: null,
    orderId: '',
    type: null, // 1:积分，2：会员
    isPaying: true,
  }

  constructor(props) {
    super(props)
    document.title = '充值中心';
    if(navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'){
      this.state.isWeiXinBrowser = true;
    }
  }

  componentDidMount() {
    app.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
    if (!app.isLogin()) {
      app.goLogin();
      return 
    }

    this.getIntegralDetailData();
    this.getVipInfo();
    this.getIntegralLit();
  }
  // 获取会员信息
  getVipInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=appVipCard/getUserAccountSurvey',
      data: {
        card_type: 2
      },
      hideLoading: true,
      success: (res) => {
       if(res.status == 0){
        that.setState({
          userVipCardInfo: res.data.user_paid_vip_card,
          vipList: res.data.all_vip_card,
        })
       }
      }
    })
  }
  // 获取积分详情
  getIntegralDetailData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      success: function (res) {
        that.setState({
          canUseIntegral: res.data.can_use_integral
        })
      }
    })
  }
  goBack = () => {
    app.turnBack();
  }

  // 获取AI积分配置
  getIntegralLit = () => {
    let that = this
    let param = {
      app_id: app.getAppId()
    }
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
      data: param,
      hideLoading: true,
      success: function(res) {
        if (res.data.length != 0) {
          that.setData({
            integralList: res.data,
          })
        }
      }
    })
  }

  selectItem = (event) => {
    let that = this;
    let id = event ? event.currentTarget.dataset.id : that.state.selectId;
    let type = event ? event.currentTarget.dataset.type : that.state.type;
    let price = event ? event.currentTarget.dataset.price : that.state.selectPrice;
    let comboid = type == 2 ? event.currentTarget.dataset.comboid : '';
    this.setData({
      selectId: id,
      selectPrice: price,
      shouldPayPrice: price,
      type: type,
      comboid: comboid,
      isPaying: false
    })
  }

  // 去充值积分
  gotoRechargeIntegral = () => {
    let that = this
    let param = {
      app_id: app.getAppId(),
      integral_config_id: +this.state.selectId,
      goods_type: 17,
    }
    if (that.state.isPaying) {
      return
    }
    this.setIsPaying(true)
    app.sendRequest({
      url: '/index.php?r=ChatAI/CreateOrder',
      data: param,
      hideLoading: true,
      method: 'POST',
      success: function(res) {
        let orderId = res.data
        app.goPay({
          orderId: orderId,
          successUrl: '/gptIndex'
        });
      },
      fail: function() {
        that.setIsPaying(false)
      },
      complete: function() {
        that.setIsPaying(false)
      }
    })
  }

  // 去充值会员卡
  gotoRechargeVip = () => {
    let that = this
    let param = {
      app_id: app.getAppId(),
      data_id: +this.state.selectId,
      price: +this.state.selectPrice,
      combo_id: this.state.comboid,
    }
    if (that.state.isPaying) {
      return
    }
    this.setIsPaying(true)
    app.sendRequest({
      url: '/index.php?r=appVipCard/addPaidVipCardOrder',
      data: param,
      hideLoading: true,
      method: 'POST',
      success: function(res) {
        let orderId = res.data
        app.goPay({
          orderId: orderId,
          successUrl: '/gptIndex'
        });
      },
      fail: function() {
        that.setIsPaying(false)
      },
      complete: function() {
        that.setIsPaying(false)
      }
    })
  }

  // 设置是否在付款中
  setIsPaying = bool => {
    this.setData({
      isPaying: bool
    })
  }
   
  render() {
    let { isWeiXinBrowser, canUseIntegral, userInfo, userVipCardInfo, integralList, vipList, selectId, type,  shouldPayPrice, isPaying  } = this.state;
    return (
      <div className='recharge_page'>
        {!isWeiXinBrowser &&
        <div className="nav">
         <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_l_big.png" alt="back" onClick={this.goBack}/>
         <div>充值中心</div>
        </div>
        }
        <div className={isWeiXinBrowser?'head_box':'head_box mar_t6vh'}>
          <div className="head">
            <img className="headimg" src={userInfo.cover_thumb?userInfo.cover_thumb:'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt="" />
            <div className="head_con">
              <div className="row">
                <div>{userInfo.phone}</div>
                {vipList.length > 0 &&
                <div className="vipimg_box">
                  <img className="vipimg"
                  src={!userVipCardInfo?"https://cdn.jisuapp.cn/static/webapp/images/chatgpt/novip.png":"https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog2.png"}/>
                </div>
                }
              </div>
              <div>积分：{ canUseIntegral }</div>
            </div>
          </div>
        </div>
        {}
        {integralList.length != 0 && (
        <div className='item_box mar_b8'>
          <div className='title'>
            <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item5.png"/>
            <div>积分充值</div>
          </div>
          
          <div className='content'>
            {integralList.map((item,index) => 
            <div className={selectId == item.id && type == 1?'item active':'item'} key={index} onClick={this.selectItem} data-type={1} data-id={item.id} data-price={item.price}>
              <div className='line1'>
                <span>{Number(item.num)}</span>
                <span>积分</span>
              </div>
              <div className='line2'>{item.price}元</div>
            </div>
            )}
          </div>
        </div>
        )}
        {vipList.length != 0 && (
        <div className='item_box'>
          <div className='title'>
            <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item4.png"/>
            <div>选择VIP套餐</div>
          </div> 
          <div className='content'>
            {vipList.map((item,index) =>
            <div className={selectId == item.id && type == 2?'item rech_item active':'item rech_item'} key={index} onClick={this.selectItem} data-type={2} data-comboid={item.combo[0].id} data-id={item.id} data-price={item.combo[0].price}>
              <div className='line3 txt-line-1'>{item.title}</div>
              <div className='line4'>
                <span>￥</span>
                <span>{item.combo[0].price}</span>
              </div>
              <div className='line5'>原价￥{item.price}</div>
              <div className='line6'>{(item.combo[0].price/30).toFixed(2)}元/天</div>
            </div>
            )}
          </div>
        </div>
        )}
        <div className='footer'>
          <div className='info'>
            <div className='total'>合计:￥<span>{selectId?shouldPayPrice:'-'}</span></div>
            <div className='agree'>支付视为您同意<span>《<a target="_blank" href="http://bbs.zhichiwangluo.com/forum.php?mod=viewthread&tid=11189&page=1&extra=#pid12695">咫尺支付协议</a>》</span></div>
          </div>
          <button className={!isPaying?'paybtn':'paybtn nopaybtn'} onClick={type == 1 ?this.gotoRechargeIntegral:this.gotoRechargeVip}>立即支付</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/recharge/Recharge.jsx